import { CurrencyValue } from '@dfl/mui-react-common';
import { SxProps } from '@mui/material';
import { useCurrency } from 'contexts/CurrencyProvider';
import { memo } from 'react';

type Props = {
  value: number;
  sx?: SxProps;
};

const CostCell = ({ value, sx }: Props) => {
  const { primary } = useCurrency();

  if (!value) return <>-</>;

  return <CurrencyValue value={value} currency={primary} sx={sx} />;
};

export default memo(CostCell);
